import { DEFAULT_DATE_FORMAT } from '@/shared/constants';
import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);
dayjs.extend(timezone);

const formatDate = (date: string) => {
	const formattedDate = dayjs(date).format(DEFAULT_DATE_FORMAT);
	const now = dayjs();

	return dayjs(`${formattedDate} ${now.format('HH:mm:ss.SSS')}`).format('YYYY-MM-DDTHH:mm:ss.SSS');
};

export { formatDate };
